import React, { Component } from 'react';
import moment from "moment-timezone";
import {map, isEmpty} from 'lodash';
import PrivateNotes from "../Common/PrivateNotes";
import EmailRemainder from "../Common/EmailRemainder";
import Loader from "../../../../Common/Component/Loader";
import { formatToCurrency } from "../../../../../Tools/formatToCurrency";
import CustomMap from "../../../ProposalDetail/Component/Common/CustomMap";

import {message} from "antd";

// mapping STATUS for hardcoded
const STATUS = {
  draft: 'Draft',
  open: 'Open',
  'open-emailed': 'Open',
  'open-printed': 'Open',
  'overdue': 'Overdue',
  paid: 'Paid',
  void: 'Void',
  "CC Auto": "CC Auto"
};

// mapping frequency for hardcoded
const FREQUENCY_MAPPING = {
  weekly: 'Weekly',
  bi_monthly: 'Every Other Week',
  once: 'Just Once',
  twice_weekly: 'Twice Weekly',
  monthly: 'Monthly'
};

// service type mapping
const SERVICE_TYPE_MAPPING = {
  "pet_waste_stations":"Pet Waste Stations",
  "pet_waste_station_bags":"Pet Waste Station Bags",
  "pet_waste_station_service":"Pet Waste Station Service",
  "common_area_cleaning":"Common Area Cleaning",
  "trash_can_service": "Trash Can Service",
  "repair":"Repair",
  "other":"Other"
}

class AccountOverview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      customer: {},
      loader: false,
      serviceOrder: {},
      emailReminderModal: false,
      cardList: {},
      cardDetail: {},
      invoiceList: {},
      invoiceSummary: {},
      complaintCount: 0,
      messageList: {},
      lastThreePaymentList:{},
    }
  }

  componentDidMount = () => {
    const {getServiceOrder, customerId, getCardList, getInvoiceList, getInvoiceSummary, getAllMessages, getCommercialCustomer,getLastThreePayment} = this.props;
    if (customerId) {
      this.setState({loader: true});
      getCommercialCustomer && getCommercialCustomer(customerId) // get customer detail
      getServiceOrder && getServiceOrder({user__uuid: customerId}) // get service order
      getCardList && getCardList({user__uuid: customerId}) // get card list
      getInvoiceList && getInvoiceList({user__uuid: customerId}) // get invoice list
      getInvoiceSummary && getInvoiceSummary({user__uuid: customerId}) // get invoice summary
      getLastThreePayment && getLastThreePayment({user__uuid: customerId}) // get Last Three Payment
      getAllMessages && getAllMessages({reason: 'complaint', user__uuid: customerId,
        created_at__lte: moment().format('YYYY-MM-DD HH:mm:ss'),
        created_at__gte: moment().subtract((moment().daysInMonth() - 1), 'days').format('YYYY-MM-DD HH:mm:ss')}) // get list of complaints
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const {
      cardDetail,
      cardList,
      serviceOrder,
      invoiceList,
      invoiceSummary,
      customer,
      lastThreePaymentList
    } = this.state;
    this.setState({loader: false});

    // get customer detail
    if (Object.keys(nextProps?.CommercialCustomer?.getCustomer).length > 0
      && JSON.stringify(nextProps?.CommercialCustomer?.getCustomer) !== JSON.stringify(customer)) {
      this.setState({ customer: nextProps?.CommercialCustomer?.getCustomer});
    }

    // get service order
    if (Object.keys(nextProps?.ServiceOrder?.data).length > 0 && JSON.stringify(nextProps?.ServiceOrder?.data) !== JSON.stringify(serviceOrder)) {
      this.setState({serviceOrder: nextProps?.ServiceOrder?.data?.results?.filter(item => item?.is_active)});
    }

    // get card list
    if (Object.keys(nextProps?.CardList?.data).length > 0 && JSON.stringify(nextProps?.CardList?.data) !== JSON.stringify(cardList)) {
      this.setState({ cardList: nextProps?.CardList?.data });
    }

    // Get invoice list
    if (Object.keys(nextProps?.Invoice?.list).length > 0
      && JSON.stringify(nextProps?.Invoice?.list) !== JSON.stringify(invoiceList)) {
      this.setState({invoiceList: nextProps?.Invoice?.list})
    }

    // send email for cc expiry
    if (Object.keys(nextProps?.EmailReminder?.sendEmail).length > 0) {
      const idx = cardList?.results?.findIndex(obj => obj.uuid === cardDetail.uuid);
      if (idx > -1) {
        Object.assign(cardList?.results?.[idx], {email_reminder: [...cardList?.results?.[idx]?.email_reminder, nextProps?.emailReminder?.sendEmail]});
        this.setState({cardList})
      }
    }

    // get last three payment
    if (Object.keys(nextProps?.LastThreePayment?.data).length > 0
      && JSON.stringify(nextProps?.LastThreePayment?.data) !== JSON.stringify(lastThreePaymentList)) {
      this.setState({lastThreePaymentList: nextProps?.LastThreePayment?.data})
    }

    // invoice summary
    if (Object.keys(nextProps?.Invoice?.invoiceSummary).length > 0
      && JSON.stringify(nextProps?.Invoice?.invoiceSummary) !== JSON.stringify(invoiceSummary)) {
      this.setState({invoiceSummary: nextProps?.Invoice?.invoiceSummary})
    }

    //get complaint message count
    if (Object.keys(nextProps?.AllMessages?.data).length > 0 &&
      JSON.stringify(nextProps?.AllMessages?.data) !== JSON.stringify(this.state?.messageList)) {
      this.setState({
        messageList: nextProps?.AllMessages?.data,
        complaintCount: nextProps?.AllMessages?.data?.count,
        loader: false
      })
    }

  }

  // convert date time from utc to local time
  UTCToLocal = (date) => {
    let stillUtc = moment.utc(date).toDate();
    return moment(stillUtc).local();
  }

  // convert date time from local to utc
  localToUTC = (date) => {
    return moment.utc(date)
  }

  // format phone number
  formatPhoneNumber = (phone) => {
    phone = phone?.replace(/\D/g, '');
    return phone?.substr(0, 3) + ' ' + phone?.substr(3, 3) + ' ' + phone?.substr(6);
  }

  // on text change
  onTextChange = (e) => {
    this.setState({[e.target.name]: e.target.value});
  };

  //toggle email remainder modal
  toggleEmailRemainder = (value) => {
    this.setState({emailReminderModal: value})
  };

  // render primary info
  renderPrimaryInfo = () => {
    const {customer} = this.state;
    const { community_name } = customer;
    const phone_number = customer?.phone_numbers?.find((obj) => obj.primary === true)
    const community_manager = {user_name: `${customer?.first_name || ''} ${customer?.last_name || ''}`, phone_number: phone_number?.phone, email: customer?.email};
    // const community_manager = {user_name: `${customer?.community_name || ''}`, phone_number: phone_number?.phone, email: customer?.email}; 
    const billing = customer?.guest_users?.filter(obj => obj.role === 'billing' && obj.primary === true)[0] || {};
    const management = customer?.guest_users?.filter(obj => obj.role === 'management' && obj.primary === true)[0] || {};

    return (
      <div className="card">
        <div className="card-title flex">
          <h5>Primary Information</h5>
        </div>
        <div className="card-body">
          {!isEmpty(community_manager) ?
            <div>
              <div className="flex flex-start mb-10">
                <div className="label">
                  <b>Community Manager:</b>
                </div>
                <div className="value">
                  <b>{community_manager?.user_name}</b>
                </div>
              </div>
              <div className="flex flex-start mb-10">
                <div className="label">
                  <b>Community Name:</b>
                </div>
                <div className="value">
                  <b>{community_name}</b>
                </div>
              </div>
              <div className="mb-10">{community_manager?.phone_number ? `+1 ${this.formatPhoneNumber(community_manager?.phone_number)} (Primary)` : ''}</div>
              <div>{community_manager?.email ? `${community_manager?.email} (Primary)` : ''}</div>
            </div> : ''
          }
          {!isEmpty(billing) ?
            <div className='mt-20'>
              <div className="flex flex-start mb-10">
                <div className="label">
                  <b>Billing:</b>
                </div>
                <div className="value">
                  <b>{billing?.user_name}</b>
                </div>
              </div>
              <div className="mb-10">{billing?.phone_number ? `+1 ${this.formatPhoneNumber(billing?.phone_number)} (Primary)` : ''}</div>
              <div>{billing?.email ? `${billing?.email} (Primary)` : ''}</div>
              <div>{billing?.address ? `${billing?.address?.address}` : ''}</div>
              <div>{billing?.address ? `, ${billing?.address?.city}, ${billing?.address?.city}, ${billing?.address?.city}` : ''}</div>
            </div> : ''
          }
          {!isEmpty(management) ?
            <div className='mt-20'>
              <div className="flex flex-start mb-10">
                <div className="label">
                  <b>Management:</b>
                </div>
                <div className="value">
                  <b>{ `${management.user_name ? management?.user_name : ''} ${management?.point_of_contact ? `, ${management?.point_of_contact}` : ''}`}</b>
                </div>
              </div>
              <div className="mb-10">{management?.phone_number ? `+1 ${this.formatPhoneNumber(management?.phone_number)} (Primary)` : ''}</div>
              <div>{management?.email ? `${management?.email} (Primary)` : ''}</div>
            </div> : ''
          }
        </div>
      </div>
    )
  };

  // render active service
  renderActiveService = (item, index) => {
    let _markers = [], multiple_locations = item?.commercial_detail?.multiple_locations, address = item?.service_address
    if (multiple_locations && multiple_locations !== "None") {
      let locations = multiple_locations?.split('MULTIPOINT')[1]
      locations = locations?.trim().substr(1, locations.trim().length - 2)
      let temp = locations?.split(', ')
      map(temp, (obj) => _markers.push({lat: obj.split(' ')[0], lng: obj.split(' ')[1]}))
    } else if (!isEmpty(address) && !isEmpty(address?.geo_location)) {
      _markers = [{ lat: address?.geo_location?.latitude, lng: address?.geo_location?.longitude }]
    }

    let total = 0
    map(item?.commercial_detail?.line_items, x => {
      const rateTax = parseFloat(x?.rate) * (parseFloat(x?.rate_tax) / 100);
      total += ((parseFloat(x?.quantity) * parseFloat(x?.rate)) + rateTax) - parseFloat(x?.discount);
    })

    return (
      <React.Fragment key={`serviceOrder${index}`}>
        <div className="card">
          <div className="card-title flex">
            <h5>Active Services</h5>
            <button className="btn btn-warning" onClick={(e) => {e.preventDefault(); this.props.tabChange(2)}}>View My Services</button>
          </div>
          {
            !isEmpty(_markers) ?
              <div className="map">
                <CustomMap markers={_markers} />
              </div> : ''
          }
          <div className="card-body">
            <div className={'flex'}>
              <span className="snum">
                {!isEmpty(item?.service_order_number) ? item?.service_order_number : '-'} {item?.community_nickname ? item?.community_nickname : ''}
              </span>
              {item?.is_paused ? <label className="status" style={{color: 'white', backgroundColor: '#08afcd'}}>Paused</label> : ''}
            </div>
            <h5 className="sadd">{(!isEmpty(item?.service_address) && !isEmpty(item?.service_address?.address)) ? `${item?.service_address?.address}, ${item?.service_address?.city}, ${item?.service_address?.state} ${item?.service_address?.zip_code}` : '-'}</h5>
            <span className="altude">{!isEmpty(item?.service_address?.geo_location?.latitude) ? `${item?.service_address?.geo_location?.latitude}, ${item?.service_address?.geo_location?.longitude}` : ``}</span>
            <div className="active_service_list">
              <div className="flex">
                <div>
                  <b>Next Service</b>
                  <span>{item?.next_service_date ? this.UTCToLocal(item?.next_service_date).format('ddd, MMM DD') : '-'}</span>
                </div>
                <div>
                  <b>Frequency</b>
                  <span>{FREQUENCY_MAPPING[item?.frequency] && FREQUENCY_MAPPING[item?.frequency]}</span>
                </div>
                <div>
                  <b>Last Service</b>
                  <span>{item?.last_cleaned ? this.UTCToLocal(item?.last_cleaned).format('ddd, MMM DD') : ''}</span>
                </div>
              </div>
              <hr/>
              <div className="sdetail">
                <div className="subs">
                  <strong>Subscription</strong>
                  {map(item?.commercial_detail?.line_items, (obj, index) => obj?.frequency !== 'once' &&
                  <span className=" d-flex justify-content-between">
                    <div className="mr-2">
                      <div key={index}>{obj?.frequency && `${FREQUENCY_MAPPING[obj?.frequency]} service, `} {SERVICE_TYPE_MAPPING[obj?.item]}
                      </div>
                    </div>
                    <strong>${obj?.total ? formatToCurrency(obj?.total) : '0.00'}</strong>
                  </span>
                  )}
                </div>
              </div>
            </div>
            <div className="total flex">
              <h5>Total per visit (Incl. Tax)</h5>
              <h5>${item?.commercial_detail?.total ? formatToCurrency(item?.commercial_detail?.total) : '0.00'}</h5>
            </div>
            {item?.last_increase_effective_date?
              <div>
                <strong class="altude fs-11" style={{marginBottom: "auto", color: "#407977",display:"block"}}>Price Increase Date: {item?.last_increase_effective_date?this.UTCToLocal(item?.last_increase_effective_date).format('MMM DD, YYYY'):"-"}</strong>
                <strong class="altude fs-11" style={{marginBottom: "auto", color: "#407977",display:"block"}}>Price Increase: {item?.last_increase_amount?item?.last_increase_amount:"-"}  {item?.last_increase_status? item?.last_increase_status === "Completed"?"(Applied)":"(Yet to be applied)" : "-"}</strong>                        
              </div>
            :
              <></>
            }
          </div>
        </div>
        {item?.calculated_price?.is_prepaid &&
        <blockquote className="horiz">
          <b>This service is on a pre-pay plan. This expires in the next 30 days.</b>
          <p className="mb-0">This customer needs to update their pre-pay plan, or move to monthly payments.</p>
        </blockquote>}
      </React.Fragment>
    )
  }

  // render invoice
  renderInvoice = () => {
    const {cardList, invoiceList, invoiceSummary, customer,lastThreePaymentList} = this.state;
    let lastThreePaymentListArr = [];
    let lengthLastThreePaymentList = lastThreePaymentList.length;
    var size = lengthLastThreePaymentList>3?3:lengthLastThreePaymentList;
    lastThreePaymentListArr = lengthLastThreePaymentList>0?lastThreePaymentList.slice(0, size):[];
    let invoice = [],  payments = [], overdue_days = 0
    map(invoiceList?.results, x => {
      if (x.status === 'overdue') overdue_days = moment(x.due_date).diff(moment(), 'days')
      if(x.status!=='draft'){
        invoice.push({date: x.invoice_date, amount: x.balance_due, type: x.status, uuid: x.uuid, service_order_uuid: x.service_order_uuid})
      }
    })
    map(invoiceList?.results, x => {
      if (x.status === 'paid') {
        payments.push({date: x.invoice_date, amount: x.balance_due, type: x.payment_method_type, uuid: x.uuid, service_order_uuid: x.service_order_uuid})
      } 
    })

    let isCardExpired = false, cardDetail = {}, displayText = '';
    const list = cardList?.results || [];
    for (let i = 0; i < list?.length; i++) {
      const item = list[i];
      const expDate = `${item?.stripe_card_details?.exp_month}/01/${item?.stripe_card_details?.exp_year}`;
      const diff = moment(expDate).diff(moment(), 'days');
      const displayDiff = moment(expDate).fromNow();
      displayText = diff < 0 ? `expired for ${displayDiff}` : `will expire ${displayDiff}`;
      if (diff <= 60) {
        isCardExpired = true;
        cardDetail = item;
        break;
      }
    }

    return (
      <div className="card invoice-payment">
        <div className="card-title flex">
          <h5>Invoices and Payments</h5>
          <button className="btn btn-warning" onClick={(e) => {e.preventDefault(); this.props.tabChange(4) }}>View Invoices</button>
        </div>
        <div className="card-body p-0">
          <span className="smhead">Last 3 Invoices</span>
          {invoice?.length > 0 ?
            map(invoice.slice(-3), (item, index) =>
              <div className={`flex scell ${item.type === 'overdue' ? 'overdue' : ''} cursor_pointer`} key={`invoice${index}`} onClick={() => {
                this.props.onInvoiceLineClick(item?.uuid, item?.service_order_uuid)
                this.props.tabChange(4)
              }}>
                <span className="sdate">{
                  item?.type === 'overdue' ?
                    <u>{moment(item?.date).format('MMMM YYYY')}</u> : moment(item?.date).format('MMMM YYYY')}</span>
                <div className="sdetail flex">
                  <span className="amt">${formatToCurrency(item?.amount)}</span>
                  <span className={`stats-color ${item.type === 'overdue' ? 'danger' : 'success'}`}><b>{STATUS[item?.type]}</b></span>
                </div>
              </div>
            ) : <div className="flex scell">-</div>
          }
        </div>
        <div>
          <span className="smhead">Last 3 Payments Made</span>
          {lastThreePaymentListArr?.length > 0 ?
            map(lastThreePaymentListArr, (item, index) =>
              <a><div  className="flex scell" key={`invoice${index} cursor_pointer`} onClick={() => {
                // this.props.onInvoiceLineClick(item?.uuid, item?.service_order_uuid)
                this.props.onInvoicePaymentHistoryClick(item?.invoice_uuid)
              }}>
                <span className="sdate">{moment(item?.created_at).format('MMMM YYYY')}</span>
                <div className="sdetail flex">
                  <span className="amt">${formatToCurrency(item?.amount)}</span>
                  <span className="stats-color success text-capitalize"><b>{item?.payment_mode}</b></span>
                </div>
              </div></a>
            ) : <div className="flex scell">-</div>
          }
        </div>
        <div className="card-body">
          {invoiceList?.results?.length > 0 ? <div className="flex flex-start">
            <h3 className="danger mb-0">{invoiceSummary?.overdue_invoices_amount?.total__sum ? formatToCurrency(invoiceSummary?.overdue_invoices_amount?.total__sum) : '0.00'}</h3>
            {customer?.suspend ? <span className="status inactive">Suspended</span> : ''}
          </div> : ''}
          {(invoiceList?.results?.length > 0 && overdue_days > 0) ? <span className="danger d-block xshead mt-10"><b>{overdue_days} days over due</b></span> : ''}
          {
            isCardExpired &&
            <blockquote className="suspend mt-10">
              <span className="danger d-block mb-10"><b>{`This customer’s credit card ${displayText}. Please contact them to update`}</b></span>
              <button
                className="btn btn-danger"
                onClick={() => {this.setState({cardDetail}); this.toggleEmailRemainder(true)}}>
                Send Reminder Email</button>
            </blockquote>
          }
        </div>
      </div>
    )
  };

  // render private notes
  renderPrivateNotes = () => {
    return <PrivateNotes
      customerId={this.props.customerId}
      getAccountNotes={this.props.getAccountNotes}
      addAccountNotes={this.props.addAccountNotes}
      AccountNotes={this.props.AccountNotes}
    />
  };

  //render customer metrics
  renderMetrics = () => {
    const {complaintCount, customer} = this.state;
    return (
      <div className="card cust-metric">
        <div className="card-title">
          <h5>Customer Metrics</h5>
        </div>
        <div className="card-body">
          <div className="flex">
            <span>
              <h2 className="success">{complaintCount || '0'} <sub className={"cursor_pointer"}><i className="las la-external-link-alt" onClick={() => this.props.tabChange(5)}/></sub></h2>
              Complaints in the past 30 days
            </span>
            <span>
              <h2 className="success">{`${customer?.customer_satisfaction_score ? customer?.customer_satisfaction_score : '0'}%`}</h2>
              Customer satisfaction score
            </span>
          </div>
        </div>
      </div>
    )
  };

  render() {
    const {loader, emailReminderModal, customer, serviceOrder, cardDetail} = this.state;

    return (
      <div className="block-row">
        <div className="card-row hide-lg">
          {loader && <Loader />}
          <div className="card-col">
            {this.renderPrimaryInfo()}
            {map(serviceOrder, this.renderActiveService)}
          </div>
          <div className="card-col">
            {this.renderInvoice()}
          </div>
          <div className="card-col">
            {this.renderPrivateNotes()}
            {this.renderMetrics()}
          </div>
          {emailReminderModal && <EmailRemainder
            visible={emailReminderModal}
            customer={customer}
            cardDetail={cardDetail}
            handleOk={(obj) => this.props.sendEmailReminder(obj)}
            handleCancel={() => this.toggleEmailRemainder(false)}
          />}
        </div>
        <div className="card-row show-lg">
          {loader && <Loader />}
          <div className="card-col">
            {this.renderPrimaryInfo()}
            {map(serviceOrder, this.renderActiveService)}
            {this.renderMetrics()}
          </div>          
          <div className="card-col">
            {this.renderInvoice()}
            {this.renderPrivateNotes()}            
          </div>
          {emailReminderModal && <EmailRemainder
            visible={emailReminderModal}
            customer={customer}
            cardDetail={cardDetail}
            handleOk={(obj) => this.props.sendEmailReminder(obj)}
            handleCancel={() => this.toggleEmailRemainder(false)}
          />}
        </div>
      </div>
    );
  }
}

export default AccountOverview;
